import { render } from "./AddCeibaDevice.vue?vue&type=template&id=54414ab9"
import script from "./AddCeibaDevice.vue?vue&type=script&lang=js"
export * from "./AddCeibaDevice.vue?vue&type=script&lang=js"
script.render = render

export default script